export default "__VITE_ASSET__zkxcl11A__"